export default __webpack_public_path__ + "static/viewRefresh-1bb3f94cf3ee1b19b5367faf87a6fbb6.gif";